import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import { Box, Paragraph, Text, TextInput, Button } from 'grommet';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { VerifyOtpMerchantCtrl } from '../Controllers/Account/Registrazione/VerifyOtpMerchantCtrl.js';
import { VerifyOtpPVCtrl } from '../Controllers/Account/Registrazione/VerifyOtpPVCtrl.js';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { logout } from '../Utils/Utility';


class InsertOTP extends Component {
    constructor(props) {
        super(props);
        this.state = {
            otpCode: '',
            disableButton: true,
            showTimeoutModal: false,
            status: ''
        }
        this.setOTP = this.setOTP.bind(this);
        this.goToLogin = this.goToLogin.bind(this);
    }

    setOTP(e) {
        this.setState({
            otpCode: e.target.value
        }, function () {
            var otpRegex = /^[0-9]+$/;
            var otpTest = otpRegex.test(this.state.otpCode)
            if (this.state.otpCode.length === 6 && otpTest) {
                this.setState({
                    disableButton: false
                })
            }
            else {
                this.setState({
                    disableButton: true
                })
            }
        })
    }

    goToLogin() {
        var ids = sessionStorage.getItem('ids')
        const self = this
        if (this.props.location.state.code === 'society') {

            VerifyOtpMerchantCtrl(function (data, status) {
                self.setState({
                    data: data,
                    status: status
                }, function () {
                    if (status === 200) {
                        this.props.history.push({
                            pathname: '/RegistrationResult',
                            state: this.state,
                            code: '0'
                        })
                    }
                });

            }, function (status, error) {
                self.setState({
                    status: status
                }, function () {
                    if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                        this.props.history.push({
                            pathname: '/RegistrationResult',
                            state: this.state,
                            code: '0'
                        })
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        //     pathname: '/login'
                        // })
                    } else if (status === 406 && error === '5704') {
                        this.setState({
                            msgOtp: 'Codice OTP scaduto',
                            otpError: true
                        })
                    }  else if (status === 406 && error === '5707') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Codice OTP non valido'
                        })
                    } else if (status === 406 && error === '5708') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Ultimo tentativo prima del blocco utenza'
                        })
                    } else if (status === 406 && error === '5709') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Utenza bloccata'
                        })
                        logout();
                    }
                })
            }, this.state, ids);

        } else {

            VerifyOtpPVCtrl(function (data, status) {
                self.setState({
                    data: data,
                    status: status
                }, function () {
                    if (status === 200) {
                        this.props.history.push({
                            pathname: '/RegistrationResult',
                            state: this.state,
                            code: '1'
                        })
                    }
                });

            }, function (status, error) {
                self.setState({
                    status: status
                }, function () {
                    if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                        this.props.history.push({
                            pathname: '/RegistrationResult',
                            state: this.state,
                            code: '0'
                        })
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        //     pathname: '/login'
                        // })
                    } else if (status === 406 && error === '5704') {
                        this.setState({
                            errorMsg: 'Codice OTP scaduto',
                            otpError: true
                        })
                    } else if (status === 406 && error === '5707') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Codice OTP non valido'
                        })
                    } else if (status === 406 && error === '5708') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Ultimo tentativo prima del blocco utenza'
                        })
                    } else if (status === 406 && error === '5709') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Utenza bloccata'
                        })
                        logout();
                    } else {
                        self.setState({
                            msgOtp: 'Si è verificato un errore, riprovare!',
                            errorOtp: true
                        })
                    }
                })
            }, this.state, ids);
        }
    }

    render() {
        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Header />

                <Box direction="column" align='center' className='background-color'>
                    <Box direction='row' >
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Abbiamo quasi finito!</h1>
                        <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                    </Box>
                    <Box style={{ height: '280px' }}>
                        <Box direction='row'>
                            <Paragraph className='textParagraph'> Per procedere alla certificazione del numero di telefono cellulare inserisci di seguito l'OTP che ti abbiamo mandato via sms al numero {this.props.location.numtel}</Paragraph>
                        </Box>


                        <Box direction='column' style={{ margin: '30px 0 50px' }} >
                            <Text className='label'>CODICE OTP</Text>
                            <TextInput id='otp' size='medium' className='inputFormdisp' onChange={this.setOTP} maxLength={6} />
                        </Box>
                    </Box>


                    <Box className='informativa' align='center'>
                        <Button className={this.state.disableButton ? 'btnform disabled' : 'btnform'} label='CONFERMA CODICE' disabled={this.state.disableButton} onClick={this.goToLogin} />
                    </Box>
                </Box>
                <Footer />
            </Box >
        )
    }
}


export default InsertOTP = withRouter(InsertOTP)